import { render } from "./DevBox.vue?vue&type=template&id=1b2c0f7e&scoped=true"
import script from "./DevBox.vue?vue&type=script&lang=js"
export * from "./DevBox.vue?vue&type=script&lang=js"

import "./DevBox.vue?vue&type=style&index=0&id=1b2c0f7e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2c0f7e"]])

export default __exports__